'use client';

import Image from 'next/image';
import { useState, type ReactNode } from 'react';

/** An unavailable CMS image should reveal the backed hero, never a broken icon. */
export function PublicHeroImage({ src, alt, fallback }: { src: string; alt: string; fallback?: ReactNode }) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  if (!src || src === failedSrc) return fallback ?? <div className="absolute inset-0 bg-[linear-gradient(115deg,#fbf8f3,#e2e9dc)]" />;
  return <Image src={src} alt={alt} fill priority sizes="100vw" className="object-cover object-center" onError={() => setFailedSrc(src)} />;
}
